import { Card, CardContent } from "@/components/ui/card";

export const ErrorState = () => {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-foreground mb-6">
          Employee Information
        </h1>
        <Card>
          <CardContent className="p-6">
            <p>Unable to load your information. Please try again later.</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
